/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-loop-func */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
import { FileExcelOutlined } from '@ant-design/icons';
import {
  Accordion,
  ActionIcon,
  Affix,
  Badge,
  Box,
  Button,
  Card,
  Center,
  Divider,
  Grid,
  Group,
  Input,
  Menu,
  Paper,
  Select,
  Stack,
  Table,
  Text,
  Title,
  Transition,
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { Dropzone, FileWithPath } from '@mantine/dropzone';
import { useForm } from '@mantine/form';
import { useWindowScroll } from '@mantine/hooks';
import { closeAllModals, useModals } from '@mantine/modals';
import { showNotification } from '@mantine/notifications';
import {
  IconArrowNarrowUp,
  IconArrowRight,
  IconBuilding,
  IconCalendar,
  IconCertificate,
  IconEye,
  IconFileCheck,
  IconLink,
  IconPlus,
  IconSearch,
  IconUpload,
  IconX,
} from '@tabler/icons-react';
import ExcelJS from 'exceljs';
import lodash from 'lodash';
import moment from 'moment';
import { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { ContractStatusEnum } from '../../../business/contracts/status';
import {
  AudienciaCodigo,
  EventBulkUpdateEnum,
  Fonte,
  ReferenciaCodigo,
  Status,
  TipoCodigo,
} from '../../../business/events/general';
import EntityPicker from '../../../components/core/EntityPicker/EntityPicker';
import { ForwardRefMultiSelect } from '../../../components/core/ForwardRefMultiSelect/ForwardRefMultiSelect';
import PageContent from '../../../components/core/PageContent/PageContent';
import PageHeader from '../../../components/core/PageHeader/PageHeader';
import ProfileCardLink from '../../../components/core/ProfileCardLink/ProfileCardLink';
import { EventGeneralProvider } from '../../../contexts/core/events/EventGeneral.context';
import useCurrentUser from '../../../hooks/useCurrentUser';
import useDynamicRefs from '../../../hooks/useDynamicRefs';
import {
  CompanyType,
  ContractStatusType,
  DocumentType,
  DocumentTypeGroup,
  EntityTypeType,
  EventRelationTypeData,
  EventStatusReasonType,
  EventStatusType,
  MovementType,
  ProposalStatusType,
  UnitOfMeasureType,
} from '../../../models/core/cache.type';
import { ContractSearchResponseType } from '../../../models/core/contracts.type';
import { EntitySearchResponseType } from '../../../models/core/entities.type';
import { EventSearchResponseType } from '../../../models/core/events.type';
import { EventDocumentMatchResponseType } from '../../../models/core/integrations.type';
import { UserType } from '../../../models/core/users.type';
import contractsService from '../../../services/core/contracts.service';
import eventsService from '../../../services/core/events.service';
import integrationsService from '../../../services/core/integrations.service';
import usersService from '../../../services/core/users.service';
import cacheUtils from '../../../utils/cache.utils';
import { Feature } from '../../../utils/constants.utils';
import { formatDateToString } from '../../../utils/formatter.utils';
import { buildFakeAuditObject, formatCNPJCPF, newGuid } from '../../../utils/helper.utils';
import EventAddEdit from '../../core/events/EventAddEdit/EventAddEdit';
import EventView from '../../core/events/EventView/EventView';

type FilterData = {
  idEmpresa: string | null;
  periodo: Date[];
  idEntidades: string[];
  unidadesSinir: string[];
};

interface MTR {
  numero: string;
  dataEmissao: Date;
  dataRecebimento: Date;
  situacao: string;
  tratamento: string;
  justificativa: string;
  geradorDestinadorGrupo: string;
  semContrato: boolean;
  correlacionadoCom: number[];
  residuos: {
    descricao: string;
    descricaoInterna?: string;
    classe: string;
    unidade: string;
    quantidadeIndicada: string;
    quantidadeRecebida: string;
  }[];
  gerador: {
    cnpjCPF: string;
    nome: string;
    observacao?: string;
  };
  transportador: {
    cnpjCPF: string;
    nome: string;
  };
  destinador: {
    cnpjCPF: string;
    nome: string;
    observacao?: string;
  };
  eventos: EventDocumentMatchResponseType[];
  eventosLinkados: EventSearchResponseType[];
}

interface Summary {
  minData: Date;
  maxData: Date;
  geradoresDistintos: {
    cnpjCPF: string;
    nome: string;
    minData: Date;
    maxData: Date;
    numeroMTRs: string[];
    noContracts: boolean;
  }[];
}

function IntegrationMTR() {
  const [currentUser] = useCurrentUser();
  const [getRef, setRef] = useDynamicRefs();
  const modals = useModals();
  const zIndex = 10000;

  const [scroll, scrollTo] = useWindowScroll();

  const [filterData, setFilterData] = useState<{
    companyData: CompanyType[];
    proposalStatusData: ProposalStatusType[];
    contractStatusData: ContractStatusType[];
    eventStatusData: EventStatusType[];
    userData: UserType[];
    entityTypeData: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
    documentTypeData: DocumentType[];
    movementTypeData: MovementType[];
    eventRelationTypeData: EventRelationTypeData[];
    eventStatusReasonData: EventStatusReasonType[];
  }>({
    companyData: [],
    proposalStatusData: [],
    contractStatusData: [],
    eventStatusData: [],
    userData: [],
    entityTypeData: [],
    unitOfMeasures: [],
    documentTypeData: [],
    movementTypeData: [],
    eventRelationTypeData: [],
    eventStatusReasonData: [],
  });

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{
    idDocumentoTipo: number;
    mtrs: MTR[];
    summary: Summary;
    eventos: EventDocumentMatchResponseType[];
    contratos: ContractSearchResponseType[];
    files: File[];
  } | null>(null);

  const form = useForm<FilterData>({
    initialValues: {
      idEmpresa: currentUser.executivo ? null : currentUser.idEmpresa.toString(),
      periodo: [
        new Date(moment(new Date()).startOf('month').add(1, 'days').format('yyyy-MM-DD')),
        new Date(),
      ],
      idEntidades: [],
      unidadesSinir: [],
    },
  });

  const reset = (resetForm: boolean) => {
    setResult(null);
    if (resetForm) {
      form.reset();
      form.setFieldValue('periodo', []);
    }
    scrollTo({ y: 0 });
  };

  const hasNoContracts = (cnpjCPF: string, contracts: ContractSearchResponseType[]) => {
    return contracts.findIndex((x) => [x.clienteCNPJ, x.clienteCPF].includes(cnpjCPF)) === -1;
  };

  const parseMTR = async (
    file: FileWithPath,
    contracts: ContractSearchResponseType[],
    ignoreEmptyFiles: boolean
  ) => {
    const buffer = await file.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    const worksheet = workbook.worksheets[0];
    const headerRow = worksheet.getRow(1);
    const headers: Record<string, number> = {};

    if (ignoreEmptyFiles && headerRow.cellCount === 0) {
      return [];
    }

    headerRow.eachCell((cell, colNumber) => {
      headers[cell.text.trim()] = colNumber;
    });

    const requiredHeaders = new Map<string, number>([
      ['Nº MTR', 1],
      ['Destinador (Nome)', 5],
      ['Destinador (CNPJ/CPF)', 6],
      ['Transportador (Nome)', 8],
      ['Transportador (CNPJ/CPF)', 9],
      ['Gerador (Nome)', 11],
      ['Gerador (CNPJ/CPF)', 12],
      ['Data de Emissão', 18],
      ['Data de Recebimento', 19],
      ['Resíduo Cód/Descrição', 22],
      ['Classe', 23],
      ['Descr. interna', 24],
      ['Quantidade indicada', 26],
      ['Quantidade recebida', 27],
      ['Unidade', 28],
      ['Justificativa', 29],
      ['Observação Destinador', 30],
      ['Tratamento', 31],
      ['Observação Gerador', 15],
      ['Situação', 20],
    ]);
    const requiredHeadersArray: [string, number][] = Array.from(requiredHeaders.entries());

    const missing = Array.from(requiredHeaders.keys()).filter((key) => !(key in headers));
    if (missing.length > 0) {
      throw new Error(`Colunas ausentes: ${missing.join(', ')}`);
    }

    const rows: MTR[] = [];
    const dupes = new Map<string, number[]>();

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) return; // skip header

      const residuo = {
        descricao: row.getCell(requiredHeadersArray[9][1]).text,
        descricaoInterna: row.getCell(requiredHeadersArray[11][1]).text,
        classe: row.getCell(requiredHeadersArray[10][1]).text,
        unidade: row.getCell(requiredHeadersArray[14][1]).text,
        quantidadeIndicada: row.getCell(requiredHeadersArray[12][1]).text,
        quantidadeRecebida: row.getCell(requiredHeadersArray[13][1]).text,
      };
      const gerador = {
        cnpjCPF: formatCNPJCPF(row.getCell(requiredHeadersArray[6][1]).text),
        nome: row.getCell(requiredHeadersArray[5][1]).text,
        observacao: row.getCell(requiredHeadersArray[18][1]).text,
      };
      const transportador = {
        cnpjCPF: formatCNPJCPF(row.getCell(requiredHeadersArray[4][1]).text),
        nome: row.getCell(requiredHeadersArray[3][1]).text,
      };
      const destinador = {
        cnpjCPF: formatCNPJCPF(row.getCell(requiredHeadersArray[2][1]).text),
        nome: row.getCell(requiredHeadersArray[1][1]).text,
        observacao: row.getCell(requiredHeadersArray[16][1]).text,
      };

      const rowData: MTR = {
        numero: row.getCell(requiredHeadersArray[0][1]).text,
        dataEmissao: moment(row.getCell(requiredHeadersArray[7][1]).text, 'DD/MM/YYYY').toDate(),
        dataRecebimento: moment(row.getCell(requiredHeadersArray[8][1]).text, 'DD/MM/YYYY').toDate(),
        situacao: row.getCell(requiredHeadersArray[19][1]).text,
        tratamento: row.getCell(requiredHeadersArray[17][1]).text,
        justificativa: row.getCell(requiredHeadersArray[15][1]).text,
        geradorDestinadorGrupo: gerador.nome + transportador.nome + destinador.nome,
        semContrato: hasNoContracts(gerador.cnpjCPF, contracts),
        correlacionadoCom: [],
        residuos: [residuo],
        gerador,
        transportador,
        destinador,
        eventos: [],
        eventosLinkados: [],
      };

      dupes.set(rowData.numero, [rowNumber - 2].concat(dupes.get(rowData.numero) ?? []));
      rows.push(rowData);
    });

    dupes.forEach((values) => {
      if (values.length > 1) {
        const targetIndex = values[0];
        for (let index = 1; index < values.length; index++) {
          rows[targetIndex].residuos.push(JSON.parse(JSON.stringify(rows[values[index]].residuos[0])));
          rows[values[index]] = null as any;
        }
      }
    });

    return rows;
  };

  function summarizeMTRs(mtrs: MTR[]): Summary {
    const datas = mtrs.map((mtr) => new Date(mtr.dataEmissao).getTime());
    const geradores = new Map<
      string,
      {
        cnpjCPF: string;
        nome: string;
        minData: Date;
        maxData: Date;
        numeroMTRs: string[];
        noContracts: boolean;
      }
    >();

    mtrs.forEach(({ gerador, dataEmissao, semContrato, numero }) => {
      const time = new Date(dataEmissao).getTime();
      if (!geradores.has(gerador.cnpjCPF)) {
        geradores.set(gerador.cnpjCPF, {
          ...gerador,
          minData: new Date(time),
          maxData: new Date(time),
          numeroMTRs: [numero],
          noContracts: semContrato,
        });
      } else {
        const e = geradores.get(gerador.cnpjCPF)!;
        e.minData = new Date(Math.min(e.minData.getTime(), time));
        e.maxData = new Date(Math.max(e.maxData.getTime(), time));
        e.numeroMTRs.push(numero);
      }
    });

    return {
      minData: new Date(Math.min(...datas)),
      maxData: new Date(Math.max(...datas)),
      geradoresDistintos: Array.from(geradores.values()),
    };
  }

  const processInBatches = async <TItem, TResult>(
    items: TItem[],
    batchSize: number,
    callback: (item: TItem) => Promise<TResult>
  ) => {
    const results: TResult[] = [];

    for (let index = 0; index < items.length; index += batchSize) {
      const batch = items.slice(index, index + batchSize);
      const batchResults = await Promise.all(batch.map(callback));
      results.push(...batchResults);
    }

    return results;
  };

  const handleReject = () => {
    setResult(null);
    showNotification({
      title: `Correlacionar MTR(s)'`,
      message: 'Limite máximo de 1 arquivo atingido.',
      color: 'red',
    });
  };

  const processMtrFiles = async (files: File[], ignoreEmptyFiles: boolean) => {
    const documentoTipo = 'MTR';
    const idDocumentoTipo =
      (await cacheUtils.listDocumentTypes())
        .filter((x) => x.codigoDocumentoGrupo === DocumentTypeGroup.Event)
        .find((x) => x.documentoTipo === documentoTipo)?.idDocumentoTipo ?? -1;

    const contracts = await contractsService.search({
      listaStatus: [
        ContractStatusEnum.AguardandoInicio,
        ContractStatusEnum.EmAndamento,
        ContractStatusEnum.EmProcessamento,
        ContractStatusEnum.EmSubstituicao,
        ContractStatusEnum.Reconciliando,
      ],
      limit: 1000,
      offset: 0,
    });

    const allMTRs: MTR[] = [];

    for (const file of files) {
      const mtrs = (await parseMTR(file, contracts, ignoreEmptyFiles)) ?? [];
      allMTRs.push(...mtrs.filter((x) => x !== null && x.situacao !== 'Cancelado'));
    }

    const summary = summarizeMTRs(allMTRs);

    const eventosSugeridos = (
      await processInBatches(summary.geradoresDistintos, 3, async (gerador) => {
        return integrationsService.eventDocumentMatchGet({
          idEmpresa: form.values.idEmpresa,
          idDocumentoTipo,
          dataInicial: moment(gerador.minData).add(-3, 'days').toISOString(),
          dataFinal: moment(gerador.maxData).add(3, 'days').toISOString(),
          listaCnpjCpf: [gerador.cnpjCPF.replace(/\D/g, '')],
        });
      })
    ).flat();

    const eventosLinkados = (
      await processInBatches(summary.geradoresDistintos, 3, async (gerador) => {
        return eventsService.search({
          idEmpresa: form.values.idEmpresa,
          idDocumentoTipo: idDocumentoTipo.toString(),
          listaNumeroDocumento: gerador.numeroMTRs,
          limit: 1000,
          offset: 0,
        });
      })
    ).flat();

    for (const mtr of allMTRs) {
      mtr.eventos = eventosSugeridos
        .filter(
          (x) =>
            [x.cnpj, x.cpf].includes(mtr.gerador.cnpjCPF) &&
            Math.abs(moment(x.data, 'YYYY-MM-DD').diff(moment(mtr.dataEmissao, 'DD/MM/YYYY'), 'days')) <= 3
        )
        .sort((a, b) => {
          const mtrData = moment(mtr.dataEmissao, 'DD/MM/YYYY');
          return Math.abs(moment(a.data).diff(mtrData)) - Math.abs(moment(b.data).diff(mtrData));
        });

      mtr.eventosLinkados = eventosLinkados.filter((x) =>
        x.resumoParcialJSON?.documentos?.find(
          (y) => y.documentoTipo === documentoTipo && y.numeroDocumento === mtr.numero
        )
      );
    }

    return {
      idDocumentoTipo,
      mtrs: allMTRs,
      summary,
      eventos: eventosSugeridos,
      contratos: contracts,
      files,
    };
  };

  const handleDrop = useCallback(async (files: FileWithPath[]) => {
    try {
      reset(true);
      setLoading(true);

      const processResult = await processMtrFiles(files, false);

      setResult(processResult);
      showNotification({
        title: `Correlacionar MTR(s)'`,
        message: 'MTR(s) importa(s) com sucesso.',
        color: 'green',
      });
    } catch (error) {
      setResult(null);
      showNotification({
        title: `Correlacionar MTR(s)'`,
        message: 'Não foi possível importar a(s) MTR(s).',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDropFromUrls = async () => {
    try {
      reset(false);
      setLoading(true);

      const getPeriods = (startDate: Date, endDate: Date) => {
        const periods: { startDate: Date; endDate: Date }[] = [];

        let year = startDate.getUTCFullYear();
        let month = startDate.getUTCMonth();

        const endYear = endDate.getUTCFullYear();
        const endMonth = endDate.getUTCMonth();

        while (year < endYear || (year === endYear && month <= endMonth)) {
          const isStartMonth = year === startDate.getUTCFullYear() && month === startDate.getUTCMonth();
          const firstDay = new Date(Date.UTC(year, month, isStartMonth ? startDate.getUTCDate() : 1));
          const lastDay = new Date(Date.UTC(year, month + 1, 0));

          if (year === endYear && month === endMonth && lastDay > endDate) {
            lastDay.setUTCDate(endDate.getUTCDate());
          }

          periods.push({ startDate: firstDay, endDate: lastDay });

          if (month === 11) {
            month = 0;
            year++;
          } else {
            month++;
          }
        }

        return periods;
      };

      const generateUrls = (unidades: string[], startDate: Date, endDate: Date) => {
        const baseUrl = 'https://mtr.sinir.gov.br/api/mtr/pesquisaManifestoRelatorioMtrAnalitico';
        const urlTemplates = [
          '/{ID}/18/8/{START_DATE}/{END_DATE}/5/0/9/0',
          '/{ID}/18/5/{START_DATE}/{END_DATE}/8/0/9/0',
          '/{ID}/18/9/{START_DATE}/{END_DATE}/8/0/5/0',
        ];

        // start date is the day after the last end date or a default start date
        const calcStartDate = new Date(
          Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate(), 0, 0, 0, 0)
        );

        calcStartDate.setUTCHours(0, 0, 0, 0);

        // yesterday's date in UTC
        const calcEndDate = new Date(
          Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate(), 0, 0, 0, 0)
        );

        const periods = getPeriods(calcStartDate, calcEndDate);
        const format = (date: Date) =>
          `${String(date.getUTCDate()).padStart(2, '0')}-${String(date.getUTCMonth() + 1).padStart(
            2,
            '0'
          )}-${date.getUTCFullYear()}`;

        const urls = [];
        for (const unidade of unidades) {
          for (const period of periods) {
            urls.push(
              ...urlTemplates.map((template) => {
                const url =
                  baseUrl +
                  template
                    .replace('{ID}', unidade)
                    .replace('{START_DATE}', format(period.startDate))
                    .replace('{END_DATE}', format(period.endDate));
                return url;
              })
            );
          }
        }

        return urls;
      };

      const urls = generateUrls(form.values.unidadesSinir, form.values.periodo[0], form.values.periodo[1]);

      const files: File[] = [];

      for (const url of urls) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Erro ao baixar o arquivo: ${url}`);

        const blob = await response.blob();
        const urlSplit = url.split('/');
        const unidade = urlSplit[6];
        const dataInicial = urlSplit[9].split('-').slice().reverse().join('-');
        const dataFinal = urlSplit[10].split('-').slice().reverse().join('-');
        const filename = `${unidade}_${dataInicial}_${dataFinal}_${urlSplit[8]}.xlsx`;
        files.push(new File([blob], filename, { type: blob.type }));
      }

      const processResult = await processMtrFiles(files, true);

      setResult(processResult);
      showNotification({
        title: `Correlacionar MTR(s)'`,
        message: 'MTR(s) importa(s) com sucesso.',
        color: 'green',
      });
    } catch (error) {
      setResult(null);
      showNotification({
        title: `Correlacionar MTR(s)'`,
        message: 'Não foi possível importar a(s) MTR(s).',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const mergeExcelFilesAndDownload = async () => {
    const fileName = `mtrs_${new Date().valueOf()}`;
    const mergedWorkbook = new ExcelJS.Workbook();
    const mergedSheet = mergedWorkbook.addWorksheet('MTRS');

    let isHeaderAdded = false;

    for (const blob of result?.files ?? []) {
      const arrayBuffer = await blob.arrayBuffer();

      const tempWorkbook = new ExcelJS.Workbook();
      await tempWorkbook.xlsx.load(arrayBuffer);

      const sheet = tempWorkbook.worksheets[0]; // Only the first sheet

      sheet.eachRow((row, rowNumber) => {
        const values = (row as any).values.slice(1); // skip the first undefined element

        // Add header only once
        if (rowNumber === 1 && !isHeaderAdded) {
          mergedSheet.addRow(values);
          isHeaderAdded = true;
        } else if (rowNumber > 1) {
          mergedSheet.addRow(values);
        }
      });
    }

    const buffer = await mergedWorkbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const buildMTRTable = useMemo(() => {
    const nodes: ReactNode[] = [];

    const handleLinkAction = async (mtrNumero: string, listaIdEventos: string[], newEvent: boolean) => {
      if (!result || listaIdEventos?.length === 0) {
        return;
      }

      const mtrAtual = result.mtrs.find((x) => x.numero === mtrNumero)!;
      const residuo = mtrAtual.residuos.length === 1 ? mtrAtual.residuos[0] : null;

      try {
        setLoading(true);

        for (const idEvento of listaIdEventos.map((x) => Number(x))) {
          await eventsService.insertDocument({
            ...buildFakeAuditObject(),
            action: 'add',
            idEvento,
            idDocumentoTipo: result.idDocumentoTipo,
            outroTipo: null,
            numeroDocumento: mtrAtual.numero,
            data: mtrAtual.dataEmissao,
            observacao: residuo
              ? `${(residuo.descricaoInterna || residuo.descricao).substring(0, 400)}|${
                  residuo.quantidadeRecebida
                }|${residuo.unidade}|${residuo.quantidadeIndicada}`
              : 'Vários itens',
            arquivos: [],
          });

          for (const mtr of result.mtrs) {
            if (mtr.numero === mtrNumero) {
              mtr.correlacionadoCom?.push(idEvento);
            }
            mtr.eventos = mtr.eventos.filter((x) => x.idEvento !== idEvento);
          }
        }

        // change the status to Agendado
        let eventos = result.eventos.filter(
          (x) => listaIdEventos.includes(x.idEvento.toString()) && x.codigoEventoStatus === Status.Pendente
        );

        if (eventos.length > 0) {
          const eventosSemResponsavel = eventos.filter((x) => !x.idResponsavel);
          if (eventosSemResponsavel.length > 0) {
            await eventsService.bulkUpdate({
              acao: EventBulkUpdateEnum.Responsavel,
              idResponsavel: currentUser.idUsuario,
              listaIdEvento: eventosSemResponsavel.map((x) => x.idEvento),
              codigoEventoStatus: null,
            });
          }

          await eventsService.bulkUpdate({
            acao: EventBulkUpdateEnum.Status,
            codigoEventoStatus: Status.Agendado,
            idResponsavel: null,
            listaIdEvento: eventos.map((x) => x.idEvento),
          });

          // update result set
          result.eventos = result.eventos.map((x) => {
            if (listaIdEventos.includes(x.idEvento.toString()) && x.codigoEventoStatus === Status.Pendente) {
              return {
                ...x,
                codigoEventoStatus: Status.Agendado,
                idResponsavel: x.idResponsavel ?? currentUser.idUsuario,
              };
            }
            return x;
          });
        }

        // change the status to PendenteMedicao
        eventos = result.eventos.filter(
          (x) => listaIdEventos.includes(x.idEvento.toString()) && x.codigoEventoStatus === Status.Agendado
        );

        if (newEvent) {
          eventos = [
            {
              idResponsavel: currentUser.idUsuario,
              idEvento: Number(listaIdEventos[0]),
              codigoEventoStatus: Status.Agendado,
            } as EventDocumentMatchResponseType,
          ];
        }

        if (eventos.length > 0) {
          const eventosSemResponsavel = eventos.filter((x) => !x.idResponsavel);
          if (eventosSemResponsavel.length > 0) {
            await eventsService.bulkUpdate({
              acao: EventBulkUpdateEnum.Responsavel,
              idResponsavel: currentUser.idUsuario,
              listaIdEvento: eventosSemResponsavel.map((x) => x.idEvento),
              codigoEventoStatus: null,
            });
          }

          await eventsService.bulkUpdate({
            acao: EventBulkUpdateEnum.Status,
            codigoEventoStatus: Status.PendenteMedicao,
            idResponsavel: null,
            listaIdEvento: eventos.map((x) => x.idEvento),
          });
        }

        setResult(JSON.parse(JSON.stringify(result)));
      } catch (error) {
        showNotification({
          title: `Correlacionar MTR(s)'`,
          message: 'Não foi correlacionar essa MTR.',
          color: 'red',
        });
      } finally {
        setLoading(false);
      }
    };

    const newEvent = (item: MTR, produtoIndex: number, contratos: ContractSearchResponseType[]) => {
      closeAllModals();
      modals.openModal({
        title: 'Evento - Adicionar',
        size: '80%',
        closeOnClickOutside: false,
        children: (
          <EventGeneralProvider>
            <EventAddEdit
              idEvento={undefined}
              newEventData={{
                idEmpresa: Number(form.values.idEmpresa),
                codigoAudiencia: AudienciaCodigo.Operacional,
                codigoEventoTipo: TipoCodigo.Coleta,
                fonte: Fonte.Contrato,
                contrato: contratos?.[0] ?? null,
                codigoReferencia: ReferenciaCodigo.ContratoResiduoPlano,
                idUsuario: currentUser.idUsuario,
                data: new Date(item.dataEmissao),
                descricao:
                  item.residuos?.[produtoIndex]?.descricaoInterna ||
                  item.residuos?.[produtoIndex]?.descricao ||
                  null,
              }}
              referenceData={filterData}
              zIndex={zIndex}
              callback={confirmActionResult}
              extras={item}
            />
          </EventGeneralProvider>
        ),
      });
    };

    const viewEvent = (item: EventSearchResponseType, mtr: MTR) => {
      closeAllModals();
      modals.openModal({
        title: (
          <Group>
            <Text>Evento - Visualizar (#{item.idEvento})</Text>
            {item.obsoleto ? (
              <Badge variant="outline" color="red" size="sm">
                obsoleto
              </Badge>
            ) : (
              ''
            )}
          </Group>
        ),
        size: '80%',
        closeOnClickOutside: false,
        children: (
          <EventView
            referenceData={filterData}
            idEvento={item.idEvento}
            zIndex={zIndex}
            callback={confirmActionResult}
            extras={mtr}
          />
        ),
      });
    };

    const confirmActionResult = async (
      items: EventSearchResponseType[],
      action: string,
      value: string | null,
      confirmed: boolean,
      extras: MTR
    ) => {
      if (!confirmed) {
        return;
      }

      if (action.startsWith('documento') && value !== extras?.numero) {
        return;
      }

      const item = items?.[0];

      try {
        // let completedAction;
        setLoading(true);

        if (!action.startsWith('documento')) {
          closeAllModals();
        }

        switch (action) {
          case 'callback':
            if (extras?.numero) {
              await handleLinkAction(extras.numero, [item.idEvento.toString()], true);
            }
            return;
          case 'callback-remover':
          case 'documento-excluir':
            for (const mtr of result!.mtrs) {
              mtr.eventos = mtr.eventos.filter((x) => x.idEvento !== item.idEvento);
              mtr.correlacionadoCom = mtr.correlacionadoCom.filter((x) => x !== item.idEvento);
              mtr.eventosLinkados = mtr.eventosLinkados.filter((x) => x.idEvento !== item.idEvento);
            }
            result!.eventos = result!.eventos.filter((x) => x.idEvento !== item.idEvento);
            setResult(JSON.parse(JSON.stringify(result)));
            break;
          default:
            break;
        }

        // showNotification({
        //   title: 'Eventos',
        //   message: `Evento ${completedAction} com sucesso.`,
        //   color: 'green',
        // });
      } catch (error: any) {
        showNotification({
          title: 'Eventos',
          message: error?.isBusinessException ? error.description : `Não foi possível ${action} o evento.`,
          color: 'red',
        });
      } finally {
        setLoading(false);
      }
    };

    const geradorDestinadorGrupo = lodash.groupBy(result?.mtrs, 'geradorDestinadorGrupo');

    for (const key of Object.keys(geradorDestinadorGrupo).sort((a: any, b: any) => a.localeCompare(b))) {
      const items = geradorDestinadorGrupo[key];
      const item0 = items[0];

      const item0Summary = result?.summary.geradoresDistintos.find(
        (x) => x.cnpjCPF === item0.gerador.cnpjCPF
      );
      const contratos =
        result?.contratos
          .filter((x) => [x.clienteCNPJ, x.clienteCPF].includes(item0.gerador.cnpjCPF))
          ?.sort((a, b) => b.idContrato - a.idContrato) ?? [];

      nodes.push(
        <Accordion
          variant="contained"
          key={`a_${item0.geradorDestinadorGrupo}`}
          defaultValue={item0Summary?.noContracts ? null : item0.gerador.cnpjCPF}
          mt="md"
        >
          <Accordion.Item key={`a_i_${item0.geradorDestinadorGrupo}`} value={item0.gerador.cnpjCPF}>
            <Accordion.Control>
              <Group justify="space-between">
                <Group gap="lg">
                  <ProfileCardLink
                    id={item0.gerador.cnpjCPF}
                    name={item0.gerador.nome || '-'}
                    nameSize="sm"
                    description={item0.gerador.cnpjCPF}
                    descriptionSize="xs"
                    showLink={false}
                  />
                  <IconArrowRight size={18} />
                  <ProfileCardLink
                    id={item0.transportador.cnpjCPF}
                    name={item0.transportador.nome || '-'}
                    nameSize="sm"
                    description={item0.transportador.cnpjCPF}
                    descriptionSize="xs"
                    showLink={false}
                  />
                  <IconArrowRight size={18} />
                  <ProfileCardLink
                    id={item0.destinador.cnpjCPF}
                    name={item0.destinador.nome || '-'}
                    nameSize="sm"
                    description={item0.destinador.cnpjCPF}
                    descriptionSize="xs"
                    showLink={false}
                  />
                </Group>
                <Group>
                  {item0Summary?.noContracts ? (
                    <Badge variant="outline" color="orange">
                      Emitente sem contrato
                    </Badge>
                  ) : items.every((x) => x.eventosLinkados.length > 0) ? (
                    <Badge variant="outline" color="blue">
                      MTR(s) já correlacionado(s)
                    </Badge>
                  ) : (
                    items.reduce((a, b) => a + b.eventos.length, 0) === 0 && (
                      <Badge variant="outline" color="red">
                        Nenhum evento sugerido
                      </Badge>
                    )
                  )}
                </Group>
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <Paper mt="md" withBorder p="md">
                <Table striped highlightOnHover withTableBorder withColumnBorders>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>Número</Table.Th>
                      <Table.Th>Data</Table.Th>
                      <Table.Th>Observação do Gerador</Table.Th>
                      <Table.Th>Resíduo</Table.Th>
                      <Table.Th>Ações</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {items.map((item) => (
                      <Table.Tr key={`t_tr_${item.numero}`}>
                        <Table.Td>{item.numero}</Table.Td>
                        <Table.Td>{formatDateToString(item.dataEmissao)}</Table.Td>
                        <Table.Td>{item.gerador.observacao || '-'}</Table.Td>
                        <Table.Td>
                          <Table key={`t_${item.numero}`} withTableBorder withColumnBorders withRowBorders>
                            <Table.Thead>
                              <Table.Tr>
                                <Table.Th>Resíduo</Table.Th>
                                <Table.Th>Unidade</Table.Th>
                                <Table.Th>Quantidade Indicada</Table.Th>
                                <Table.Th>Quantidade Recebida</Table.Th>
                                <Table.Th>Ações</Table.Th>
                              </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                              {item.residuos.map((p, i) => (
                                <Table.Tr key={`t_tr_r_${i}`}>
                                  <Table.Td style={{ maxWidth: 600 }}>
                                    {p.descricaoInterna || p.descricao}
                                  </Table.Td>
                                  <Table.Td>{p.unidade}</Table.Td>
                                  <Table.Td>{p.quantidadeIndicada || '-'}</Table.Td>
                                  <Table.Td>{p.quantidadeRecebida || '-'}</Table.Td>
                                  <Table.Td width={45}>
                                    {!item.semContrato ? (
                                      <Button
                                        leftSection={<IconPlus size={14} />}
                                        color="primary"
                                        size="xs"
                                        onClick={() => {
                                          newEvent(item, i, contratos);
                                        }}
                                      >
                                        Evento
                                      </Button>
                                    ) : (
                                      <>-</>
                                    )}
                                  </Table.Td>
                                </Table.Tr>
                              ))}
                            </Table.Tbody>
                          </Table>
                        </Table.Td>
                        <Table.Td width={355}>
                          {item.eventos.length === 0 &&
                          item.correlacionadoCom?.length + item.eventosLinkados?.length === 0 ? (
                            <Badge variant="outline" color="red">
                              Nenhum evento sugerido
                            </Badge>
                          ) : (
                            <>
                              {item.eventos.length > 0 && (
                                <Group gap="xs" grow>
                                  <ForwardRefMultiSelect
                                    key={`s_mtr_event_${item.numero}_${
                                      item.eventosLinkados.length + item.correlacionadoCom.length
                                    }`}
                                    ref={setRef(`s_mtr_event_${item.numero}`)}
                                    leftSection={<Feature.Home.Event.icon size={15} />}
                                    maxDropdownHeight={400}
                                    style={{ minWidth: 300 }}
                                    renderOption={({ option }) => {
                                      const evento = result?.eventos.find(
                                        (x) => x.idEvento === Number(option.value)
                                      );
                                      if (!evento) {
                                        return <div>{option.label}</div>;
                                      }

                                      const { residuo, veiculo, tratamento, destinoFinal } =
                                        evento.resumoJSON!;

                                      return (
                                        <Paper shadow="xs" p="md" withBorder style={{ minWidth: 250 }}>
                                          <>
                                            <Divider
                                              my="sm"
                                              variant="dashed"
                                              label={`#${evento.idEvento}`}
                                              labelPosition="center"
                                            />
                                            <Group justify="space-between" wrap="nowrap">
                                              <Badge size="sm" variant="outline">
                                                {
                                                  filterData.eventStatusData.find(
                                                    (x) => x.codigoEventoStatus === evento.codigoEventoStatus
                                                  )?.eventoStatus
                                                }
                                              </Badge>
                                              <Text size="sm">{formatDateToString(evento.data)} </Text>
                                            </Group>
                                          </>

                                          <>
                                            <Divider
                                              my="sm"
                                              variant="dashed"
                                              label={
                                                <Group>
                                                  <Feature.Reference.Residue.icon size={15} />
                                                  Resíduo
                                                </Group>
                                              }
                                              labelPosition="center"
                                            />
                                            <Stack gap="xs">
                                              <Text size="sm">{residuo?.residuoCliente}</Text>
                                              <Text fs="italic" size="xs">
                                                {residuo?.residuo}
                                              </Text>
                                            </Stack>
                                          </>

                                          {veiculo && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <Feature.Reference.Vehicle.icon size={15} />
                                                    {veiculo.residuoVeiculo}
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group>
                                                <Text size="xs">
                                                  {veiculo?.cotacao.fornecedorNomeFantasia ||
                                                    veiculo?.cotacao.fornecedorRazaoSocial}
                                                </Text>
                                              </Group>
                                            </>
                                          )}

                                          {tratamento && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <Feature.Reference.Treatment.icon size={15} />
                                                    {tratamento.residuoTratamento}
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group>
                                                <Text size="xs">
                                                  {tratamento?.cotacao.fornecedorNomeFantasia ||
                                                    tratamento?.cotacao.fornecedorRazaoSocial}
                                                </Text>
                                              </Group>
                                            </>
                                          )}

                                          {destinoFinal && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <Feature.Reference.Destination.icon size={15} />
                                                    {destinoFinal.residuoDestinoFinal}
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group>
                                                <Text size="xs">
                                                  {destinoFinal?.cotacao.fornecedorNomeFantasia ||
                                                    destinoFinal?.cotacao.fornecedorRazaoSocial}
                                                </Text>
                                              </Group>
                                            </>
                                          )}

                                          {evento.resumoJSON?.documentos && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <IconCertificate size={15} />
                                                    Documentos
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group gap="xs">
                                                {evento.resumoJSON.documentos.map((y) => {
                                                  return (
                                                    <Group gap="xs" key={newGuid()}>
                                                      <Badge
                                                        key={newGuid()}
                                                        variant="outline"
                                                      >{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
                                                      {y.observacao?.split('|')?.length ===
                                                        (y.documentoTipo === 'MTR'
                                                          ? 3
                                                          : y.documentoTipo === 'Nota Fiscal'
                                                          ? 5
                                                          : -2) && (
                                                        <Badge
                                                          key={newGuid()}
                                                          style={{ marginLeft: -10 }}
                                                          color="green"
                                                          variant="outline"
                                                        >
                                                          {y.documentoTipo === 'MTR'
                                                            ? `${y.observacao.split('|')[1]} - ${
                                                                y.observacao.split('|')[2]
                                                              }`
                                                            : `${y.observacao.split('|')[2]} - ${
                                                                y.observacao.split('|')[3]
                                                              }`}
                                                        </Badge>
                                                      )}
                                                    </Group>
                                                  );
                                                })}
                                              </Group>
                                            </>
                                          )}
                                        </Paper>
                                      );
                                    }}
                                    label="Eventos"
                                    placeholder="Selecione..."
                                    data={item.eventos.map((x) => ({
                                      value: x.idEvento.toString(),
                                      label: `${x.idEvento} - ${x.resumoJSON?.residuo?.residuoCliente}`,
                                    }))}
                                    searchable
                                    clearable
                                  />
                                  <Input.Wrapper>
                                    <Input.Label> </Input.Label>
                                    <Input.Wrapper>
                                      <ActionIcon
                                        size="sm"
                                        color="green"
                                        variant="outline"
                                        onClick={async () => {
                                          const ref = getRef(`s_mtr_event_${item.numero}`)?.current;
                                          await handleLinkAction(
                                            item.numero,
                                            ref?.getSelectedValues() ?? [],
                                            false
                                          );
                                        }}
                                      >
                                        <IconLink size={18} />
                                      </ActionIcon>
                                    </Input.Wrapper>
                                  </Input.Wrapper>
                                </Group>
                              )}
                              {item.correlacionadoCom?.length + item.eventosLinkados?.length > 0 && (
                                <Center mt={item.eventos.length > 0 ? 'md' : undefined}>
                                  <Menu withArrow zIndex={zIndex}>
                                    <Menu.Target>
                                      <Button
                                        color={
                                          item.correlacionadoCom?.length > 0
                                            ? 'green'
                                            : `${Feature.Home.Event.color}.4`
                                        }
                                        leftSection={<IconEye size={14} />}
                                        size="xs"
                                      >
                                        {`${'Correlacionado com '} ${
                                          item.correlacionadoCom?.length + item.eventosLinkados?.length
                                        } ${
                                          item.correlacionadoCom?.length + item.eventosLinkados?.length > 1
                                            ? 'eventos'
                                            : 'evento'
                                        }`}
                                      </Button>
                                    </Menu.Target>

                                    <Menu.Dropdown style={{ minWidth: 150 }}>
                                      {item.correlacionadoCom.map((x) => (
                                        <Menu.Item
                                          key={item.numero + x}
                                          leftSection={<Feature.Home.Event.icon size={14} />}
                                          color="green"
                                          onClick={() => {
                                            viewEvent({ idEvento: Number(x) } as any, item);
                                          }}
                                        >
                                          {x}
                                        </Menu.Item>
                                      ))}
                                      {item.eventosLinkados.map((x) => (
                                        <>
                                          <Menu.Item
                                            key={item.numero + x.idEvento}
                                            leftSection={x.idEvento}
                                            color={`${Feature.Home.Event.color}.4`}
                                            onClick={() => {
                                              viewEvent(x, item);
                                            }}
                                          >
                                            <>
                                              <Stack gap="xs">
                                                {x.resumoParcialJSON?.documentos?.map((y) => {
                                                  return (
                                                    <Group gap="xs" key={newGuid()}>
                                                      <Badge
                                                        key={newGuid()}
                                                        variant="outline"
                                                        size="sm"
                                                      >{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
                                                      {y.observacao?.split('|')?.length ===
                                                        (y.documentoTipo === 'MTR'
                                                          ? 3
                                                          : y.documentoTipo === 'Nota Fiscal'
                                                          ? 5
                                                          : -2) && (
                                                        <Badge
                                                          key={newGuid()}
                                                          style={{ marginLeft: -10 }}
                                                          color="green"
                                                          variant="outline"
                                                        >
                                                          {y.documentoTipo === 'MTR'
                                                            ? `${y.observacao.split('|')[1]} - ${
                                                                y.observacao.split('|')[2]
                                                              }`
                                                            : `${y.observacao.split('|')[2]} - ${
                                                                y.observacao.split('|')[3]
                                                              }`}
                                                        </Badge>
                                                      )}
                                                    </Group>
                                                  );
                                                })}
                                              </Stack>
                                            </>
                                          </Menu.Item>
                                          <Divider key={`divider_${item.numero}_${x.idEvento}`} />
                                        </>
                                      ))}
                                    </Menu.Dropdown>
                                  </Menu>
                                </Center>
                              )}
                            </>
                          )}
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                </Table>
              </Paper>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      );
    }

    return nodes;
  }, [filterData.eventStatusData, getRef, result, setRef]);

  useEffect(() => {
    const loadFilterData = async () => {
      setLoading(true);

      setFilterData({
        companyData: await cacheUtils.listCompanies(),
        proposalStatusData: await cacheUtils.listProposalStatuses(),
        contractStatusData: await cacheUtils.listContractStatuses(),
        eventStatusData: await cacheUtils.listEventStatuses(),
        userData: await usersService.search({
          limit: 1000,
          offset: 0,
        }),
        entityTypeData: await cacheUtils.listEntityTypes(),
        unitOfMeasures: await cacheUtils.listUnityOfMeasures(),
        documentTypeData: (await cacheUtils.listDocumentTypes()).filter(
          (x) => x.codigoDocumentoGrupo === DocumentTypeGroup.Event || !x.codigoDocumentoGrupo
        ),
        movementTypeData: await cacheUtils.listMovementTypes(),
        eventRelationTypeData: await cacheUtils.listEventRelationTypes(),
        eventStatusReasonData: await cacheUtils.listEventStatusReasonTypes(),
      });

      setLoading(false);
    };

    loadFilterData();
  }, []);

  return (
    <Card>
      <PageHeader
        feature={Feature.Home.Integration}
        title="Correlacionar MTR(s)"
        description="Importe a planilha com a lista de MTRs exportada pelo sistema do SINIR."
        buttons={[
          (
            <Select
              leftSection={<IconBuilding size={15} />}
              placeholder="Empresa"
              data={filterData.companyData.map((x) => {
                return {
                  value: x.idEmpresa.toString(),
                  label: x.empresa,
                };
              })}
              searchable
              clearable={currentUser.executivo}
              disabled={!currentUser.executivo}
              {...form.getInputProps('idEmpresa')}
            />
          ) as any,
        ]}
      />
      <PageContent>
        <Box>
          <Paper shadow="xs" p="md" withBorder>
            <Paper shadow="xs" p="md" withBorder>
              <Grid columns={12}>
                <Grid.Col span={2}>
                  <div>
                    <Input.Wrapper
                      label="Data Inicial / Final"
                      description="Filtro: entre"
                      style={{ marginBottom: 5 }}
                      required
                    >
                      <div />
                    </Input.Wrapper>
                    <DatePickerInput
                      type="range"
                      placeholder="Datas"
                      leftSection={<IconCalendar size={15} />}
                      clearable
                      numberOfColumns={2}
                      allowSingleDateInRange
                      // maxDate={new Date()}
                      required
                      {...form.getInputProps('periodo')}
                    />
                  </div>
                </Grid.Col>
                <Grid.Col span={9}>
                  <EntityPicker
                    label="Entidades"
                    description="Filtro: igual"
                    formItem={form.getInputProps('idEntidades')}
                    idsToBeDisabled={[]}
                    disabled={false}
                    required
                    callback={(item: EntitySearchResponseType | EntitySearchResponseType[] | null) => {
                      if (Array.isArray(item)) {
                        form.setFieldValue(
                          'idEntidades',
                          item.map((x) => x.idEntidade.toString())
                        );
                        form.setFieldValue(
                          'unidadesSinir',
                          item.map((x) => x.unidadeSinir!.toString())
                        );
                      }
                    }}
                    zIndex={zIndex}
                    useCache
                    allowMultiple
                    query="sinir"
                  />
                </Grid.Col>
                <Grid.Col span={1}>
                  <div>
                    <Input.Wrapper label="&nbsp;" description="&nbsp;" style={{ marginBottom: 5 }}>
                      <div />
                    </Input.Wrapper>
                    <Button
                      leftSection={<IconSearch size={18} />}
                      color="primary"
                      disabled={
                        form.values.periodo.filter((x) => x).length !== 2 ||
                        form.values.idEntidades.filter((x) => x).length === 0
                      }
                      loading={loading}
                      onClick={handleDropFromUrls}
                    >
                      Buscar
                    </Button>
                  </div>
                </Grid.Col>
              </Grid>
            </Paper>
            <Divider label="ou" mt="md" mb="md" />
            <Paper shadow="xs" p="md" withBorder>
              <Dropzone
                onDrop={handleDrop}
                onReject={handleReject}
                maxFiles={10}
                maxSize={5 * 1024 ** 2}
                accept={{ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] }}
                loading={loading}
              >
                <Group justify="center" gap="xl" mih={150} style={{ pointerEvents: 'none' }}>
                  <Dropzone.Accept>
                    <IconFileCheck size={50} stroke={1.5} />
                  </Dropzone.Accept>
                  <Dropzone.Reject>
                    <IconX size={50} stroke={1.5} />
                  </Dropzone.Reject>
                  <Dropzone.Idle>
                    <IconUpload size={50} stroke={1.5} />
                  </Dropzone.Idle>

                  <div>
                    <Text size="xl" inline>
                      Arraste arquivos XLSX aqui ou clique para selecionar
                    </Text>
                    <Text size="sm" c="dimmed" inline mt={7}>
                      Até 10 relatórios de MTR do SINIR
                    </Text>
                  </div>
                </Group>
              </Dropzone>
            </Paper>
          </Paper>
          {result === null ? (
            <></>
          ) : (
            // <Paper mt="md" withBorder p="md">
            //   <Title order={4} mb="md">
            //     MTR(s) importada(s)
            //   </Title>
            //   <>
            //     {buildSummary()}
            //     <Table withTableBorder withColumnBorders>
            //       <Table.Tbody>{buildMTRTable}</Table.Tbody>
            //     </Table>
            //   </>
            // </Paper>

            <Paper mt="md" withBorder p="md">
              <Group justify="space-between">
                <Title order={4}>MTR(s) importada(s)</Title>
                {result.files.length > 0 && result.mtrs.length > 0 && (
                  <Button
                    color="accent"
                    leftSection={<FileExcelOutlined size={18} />}
                    onClick={() => {
                      mergeExcelFilesAndDownload();
                    }}
                  >
                    Exportar
                  </Button>
                )}
              </Group>
              <>
                {/* {buildSummary()} */}
                {/* <Accordion
                    multiple
                    variant="contained"
                    defaultValue={result.summary.emitentesDistintos
                      .filter((x) => !x.noContracts)
                      .map((y) => y.cnpjCPF)}
                  > */}
                {buildMTRTable}
                {/* </Accordion> */}
              </>
            </Paper>
          )}
        </Box>
      </PageContent>

      <Affix position={{ bottom: 20, left: '50%' }}>
        <Transition transition="slide-up" mounted={scroll.y > 0}>
          {(transitionStyles) => (
            <Button
              leftSection={<IconArrowNarrowUp size={18} />}
              style={transitionStyles}
              color="secondary"
              onClick={() => scrollTo({ y: 0 })}
            >
              Ir ao topo
            </Button>
          )}
        </Transition>
      </Affix>
    </Card>
  );
}

export default IntegrationMTR;
